import React, { useCallback, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';


import { Modal, Button, Input, Form } from '@gpstrackit/gtc-react-controls';
import { NotificationContainer } from "Components/Notifications";
import { NotificationManager } from 'Components/Notifications';

import { LogManagerConsole } from 'Core/logManager';
import { reset, templateEditSave, closeModal } from './redux/slice';


export const EditModal = ({ onRefresh }) => {

    //constants
    const { messages } = useIntl();
    const formRef = Form.useForm();
    const dispatch = useDispatch();

    //Redux States
    const user = useSelector(state => state.securityRedux.user);
    const { loading, data, error, result, open } = useSelector(state => state.templateEditRedux);

    //Local States
    const [id, setId] = useState();

    //callbackks
    const onClose = useCallback((refresh) => {
        dispatch(closeModal());

        onRefresh && onRefresh(refresh);
        dispatch(reset());
    })

    //effects
    useEffect(() => {
        LogManagerConsole("TEMPLATE", "edit", "data", data, "result", result, "error", error);

        //validate if the data is not empty and the id is not set
        if (data && !id) {
            setId(data.id);
            formRef.setValues({ firstName: data.firstName, lastName: data.lastName });
        }

        //validate if the result is not empty
        if (result) {
            dispatch(reset({ result: null }));

            NotificationManager.success(
                messages['success'],
                messages['templateList_saveSuccessfully'],
                3000,
                null,
                null,
                'success',
            );

            onClose(true);
        }

        //validate if the error is not empty
        if (error) {
            dispatch(reset({ error: null }));
            NotificationManager.error(
                error?.error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'error',
            );
        }

    }, [data, result, error]);

    return (
        <Modal
            title={data ? messages['templateEdit_edit'] : messages['templateEdit_create']}
            open={open}
            handleClose={onClose}
            position="right"
            size="small"
            loading={loading}
            closeButton={false}
            footer={(
                <div>
                    <Button
                        variant="secondary"
                        onClick={onClose}
                        style={{ marginRight: "5px" }}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>

                    <Button
                        onClick={(e) => formRef.submit()}
                        variant="primary"
                        isDisabled={loading}
                    >
                        {data ? `${messages["save"]}` : `${messages["add"]}`}
                    </Button>
                </div>
            )}
        >
            <div style={{ padding: "15px" }}>
                <Form ref={formRef.ref}
                    onValidSubmit={(values) => {
                        LogManagerConsole("TEMPLATE", "onValidSubmit", values);
                        dispatch(templateEditSave({ ...values, id: id }));
                    }}
                >
                    <Form.Item
                        name="firstName"
                        label={messages['templateList_firstName']}
                        rules={[{ required: true, message: 'required_field' }]}
                    >
                        <Input
                            id="name"
                            type="text"
                            placeholder={messages['templateList_firstName']}
                            autoFocus
                            maxLength={30}
                        />
                    </Form.Item>
                    <Form.Item
                        name="lastName"
                        label={messages['templateList_lastName']}
                    >
                        <Input
                            id="estimateCost"
                            type="currency"
                            maxLength={30}
                            placeholder={messages['templateList_lastName']}
                        />
                    </Form.Item>
                </Form>
            </div>
            <NotificationContainer />
        </Modal>
    );
}

export default EditModal;